// extracted by mini-css-extract-plugin
export default {"showList":"styles_showList__7-uAz","isLiked":"styles_isLiked__N-y1u","notClicked":"styles_notClicked__8rE--"};